module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_8004.4a90a479.png";